import { LandingNav } from './components/LandingNav';
import { HeroSection } from './components/HeroSection';
import { SocialProofBar } from './components/SocialProofBar';
import { HowItWorks } from './components/HowItWorks';
import { FeaturesGrid } from './components/FeaturesGrid';
import { ForCustomers } from './components/ForCustomers';
import { CtaSection } from './components/CtaSection';
import { LandingFooter } from './components/LandingFooter';

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-white">
      <LandingNav />
      <main>
        <HeroSection />
        <SocialProofBar />
        <HowItWorks />
        <FeaturesGrid />
        <ForCustomers />
        <CtaSection />
      </main>
      <LandingFooter />
    </div>
  );
}
